import UAParser from "ua-parser-js";

export class DeviceBrowserDetection {
    private browser: UAParser.IBrowser;
    constructor(private parser: UAParser) {
        this.browser = this.parser.getBrowser();
    }

    /**
     * Returns the name of the browser
     *
     * Possible values :
     * Amaya, Android Browser, Arora, Avant, Baidu, Blazer, Bolt, Camino, Chimera, Chrome,
     * Chromium, Comodo Dragon, Conkeror, Dillo, Dolphin, Doris, Edge, Epiphany, Fennec,
     * Firebird, Firefox, Flock, GoBrowser, iCab, ICE Browser, IceApe, IceCat, IceDragon,
     * Iceweasel, IE [Mobile], Iron, Jasmine, K-Meleon, Konqueror, Kindle, Links,
     * Lunascape, Lynx, Maemo, Maxthon, Midori, Minimo, MIUI Browser, [Mobile] Safari,
     * Mosaic, Mozilla, Netfront, Netscape, NetSurf, Nokia, OmniWeb, Opera [Mini/Mobi/Tablet],
     * Phoenix, Polaris, QQBrowser, RockMelt, Silk, Skyfire, SeaMonkey, SlimBrowser, Swiftfox,
     * Tizen, UCBrowser, Vivaldi, w3m, Yandex
     */
     public get name() {
        // ua-parser-js returns human readable names like "Mobile Safari". I want without spaces to be able to use them as keys in an object
        // example in the external_links_consts.js where macos and safari are used as keys.
        // also, we make it lowercase for comodity
        return this.browser.name.replace(/\s/g, "").toLowerCase();
    }

    /**
     * Returns the major version of the browser
     */
    public get version() {
        return parseInt(this.browser.version.split(".")[0]);
    }

    /**
     * Is it a Firefox?
     */
    public get isFirefox() {
        return this.browser.name === "firefox";
    }


    /**
     * Is it a Chrome?
     */
    public get isChrome() {
        return this.browser.name === "chrome";
    }


    /**
     * Is it a Safari?
     */
    public get isSafari() {
        // Can be "Safari" or "Mobile Safari"
        return this.browser.name.indexOf("safari") !== -1;
    }

    /**
     * Is it a Opera?
     */
    public get isOpera() {
        // Can be "Opera", "Opera Mobi", "Opera Mini", "Opera Tablet"
        return this.browser.name.indexOf("opera") !== -1;
    }


    /**
     * Is browser an Edge instance?
     */
    public get isEdge() {
        return this.browser.name === "Edge";
    }

    getAllowCameraAttributeValue(){
        if (['vivaldi', 'samsung', 'silk', 'edge-chromium', 'chrome', 'chromium-webview', 'opera'].indexOf(this.browser.name) !== -1) {
            return "camera *";
        }

        return "camera";
    }

}
